import styled from 'styled-components';

export const StSliderOuterWrapper = styled.div`
    position: relative;
`;

export const StSliderWrapper = styled.div`
    overflow-x: auto;
    overflow-y: hidden;
    scroll-behavior: smooth;
    background-color: transparent;
    //disable scrollbar for firefox ie and chrome
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
        width: 0 !important;
    }
`;

export const StSliderContainer = styled.article<{
    isAnyTileHovered: boolean;
    sliderHeight: number;
    sliderHeightHover: number;
}>`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    position: inherit;
    background-color: transparent;

    height: ${({ isAnyTileHovered, sliderHeight, sliderHeightHover }) => {
        if (isAnyTileHovered) {
            return sliderHeightHover; //overlaps with other product groups
        } else {
            return sliderHeight; //doesn't overlap with other product groups
        }
    }}px;
`;

export const StSliderTileComponentWrapper = styled.div`
    min-width: 175px;
    margin: 0 10px;
`;

export const StContainerShadow = styled.div`
    background-image: radial-gradient(at left center, rgba(0, 0, 0, 0.5) 0px, rgba(255, 255, 255, 0) 70%);
    content: ' ';
    height: 300px;
    position: absolute;
    top: 0;
    width: 20px;
    z-index: 50;
`;

export const StContainerShadowLeft = styled(StContainerShadow)<{
    shadowOffsetX: number;
    isVisible: boolean;
}>`
    left: ${({ shadowOffsetX }) => shadowOffsetX}px;
    display: ${({ isVisible }) => {
        return isVisible ? 'block' : 'none';
    }};
`;

export const StContainerShadowRight = styled(StContainerShadow)<{
    shadowOffsetX: number;
    isVisible: boolean;
}>`
    right: ${({ shadowOffsetX }) => shadowOffsetX}px;
    transform: rotate(180deg);
    display: ${({ isVisible }) => {
        return isVisible ? 'block' : 'none';
    }};
`;
